import axios from 'axios';
import { isEmpty, showMessage, toastr } from '../cores';
import { api_url } from '../cores/keys';
import { GET_POWERBALLBETTINGLIST, SET_BETDATA, SET_BETTYPE, SET_POWERBALL_RATES, SET_MINIGAME_TYPE, SET_MINICHECK } from './types';
import store from '../store';
import { getUserInfo, logoutUser } from './userActions';
import { SetCurrentPage } from './pageAction';

export const ClearMiniBetStore = () => dispatch => {
   dispatch({
      type: SET_BETDATA,
      payload: {
         odd_key: '',
         rate: 0,
         name: '-'
      }
   })
}

export const GetPowerballBettingList = data => dispatch => {
   dispatch({
      type: GET_POWERBALLBETTINGLIST,
      payload: data
   })
}

export const GetBettingList = (data) => dispatch => {

   axios.post(api_url + '/api/Minigame/getBettingHistory', data)
      .then(res => {

         if (res.data.status)
            return showMessage(res.data.message);

         dispatch(GetPowerballBettingList(res.data.bets));
         dispatch(SetCurrentPage(res.data));

      })
      .catch(err => {
         console.error('err: ', err);
         //console.log('error:', err);
         if (err.response && err.response.status === 401)
               return dispatch(logoutUser());
         toastr.warning('잠시후 다시 시도해주세요.');
      })

}

export const SetBetType = data => dispatch => {
   dispatch({
      type: SET_BETTYPE,
      payload: data
   })
}

export const SetBetData = (data) => dispatch => {
   // //console.log(data)
   dispatch({
      type: SET_BETDATA,
      payload: data
   })
}

// export const CancelBetting = id => dispatch => {


//    const { type } = store.getState().mini;

//    axios.post(api_url + '/api/bettings/cancel', {
//       type: 'EOSPowerball',
//       id: id
//    })
//       .then(res => {
//          showMessage(res.data.message);
//          if (!res.data.status)
//             dispatch(GetBettingList({type}));
//       })
//       .catch(err => {
//          console.error('err: ', err);
         // if(store.getState().user.isAuthenticated)
         //    return dispatch(dispatch(logoutUser()));
//          if (err.response && err.response.status === 401)
//             dispatch(logoutUser());
//       })

// }

export const DoMiniBetting = (amount) => dispatch => {
   const { data, type } = store.getState().mini;
   const page = store.getState().page;

   // //console.log(data)

   if (isEmpty(data.odd_key) || isEmpty(data.rate) || data.name === '-') {
      return toastr.warning('선택해주세요.')
   }

   dispatch(ClearMiniBetStore());
   axios.post(api_url + '/api/Minigame/betting',
      {
         type: (type).toString(),
         amount: amount,
         odd_key: data.odd_key,
         name: data.name
      }
   )
      .then(res => {
         showMessage(res.data.message);
         if (!res.data.status) {
            dispatch(ClearMiniBetStore());
            dispatch(GetBettingList({type: type.toString(), page: 1, perPage: page.perPage, gameResult: ""}));
            dispatch(getUserInfo());
         }
      })
      .catch(err => {
         console.error('err: ', err);
         if (err.response && err.response.status === 401)
            dispatch(logoutUser());
         else
            toastr.warning('배팅이 실패되었습니다.');
            //console.log(err)
      })
}

export const SetMiniRates = data => dispatch => {
   dispatch({
      type: SET_POWERBALL_RATES,
      payload: data
   })
}

export const setType = (type) => dispatch => {
    dispatch({
        type: SET_MINIGAME_TYPE,
        payload: type
    })
}

export const setMiniCheck = (type) => dispatch => {
    dispatch({
        type: SET_MINICHECK,
        payload: type
    })
}


// WEBPACK FOOTER //
// ./src/common/actions/miniAction.js